import { ScaleLinear, Selection, select } from "d3";

// declare var MorphSVGPlugin;

export interface LabelConf {
    axis: { yPos: number, xPos: number };
    linescaleWidth: number;
    height: number,
    xScale: ScaleLinear<number, number>;
    svg: Selection<SVGElement, any, any, any>;
    marginX: number;
    allLabels: LsLabel[];
    threshhold: number;
    vBoxWidth: number;
    marginY: number;
}

export class LsLabel {

    private svg: Selection<SVGElement, any, any, any>;
    private readonly positionProps: {
        x: number;
        y: number;
    }
    private readonly baseY: number;
    // private readonly svgWidth: number;
    private readonly linescaleWidth: number;
    private readonly vBoxWidth: number;

    private textBox: Selection<SVGTextElement, any, any, any>;
    private dropLine: Selection<any, any, any, any>;
    private tailLine: Selection<SVGLineElement, any, any, any>;

    public readonly text: string;
    private readonly _allLabels: LsLabel[];
    private wrapped: boolean = false;
    private readonly threshhold: number;
    /**
     * X coordinate of rating value (score)
     * NOTE: Use this to determine positions, NOT the raw rating value as the domain values are reversed
     */
    readonly valueCoordinate: number;

    constructor(
        public readonly score: number,
        text: string,
        private conf: LabelConf,
        private isAnchor: boolean
    ) {
        this.text = text;
        this.svg = conf.svg;
        this.textBox = this.svg.append('text').text(text);

        // TODO: Move this to the render method for smoother paints...?
        this.dropLine = this.svg.append('line');
        this.tailLine = this.svg.append('line');

        if (isAnchor) {
            this.textBox.attr('class', 'anchor');
            this.dropLine.attr('class', 'item-line anchor');
            this.tailLine.attr('class', 'item-line anchor');
        }


        this.positionProps = {
            x: Math.floor(conf.xScale(score) + conf.axis.xPos),
            y: Math.floor(conf.axis.yPos + 32)
        };
        this.baseY = conf.axis.yPos;
        this.linescaleWidth = conf.linescaleWidth;
        this._allLabels = conf.allLabels;
        this.threshhold = conf.threshhold;
        this.vBoxWidth = conf.vBoxWidth;
        this.valueCoordinate = conf.xScale(score);
    }

    get siblings(): LsLabel[] {
        return this._allLabels.filter(label => label != this);
    }

    get baseX(): number {
        return this.positionProps.x;
    }

    get tailY(): number {
        // TODO: Hardcoded offset for now
        return Math.floor(this.boxY - 4);// + this.conf.marginY;
    }

    get boxHeight(): number {
        // return this._boxProps.height;
        return this.textBox.node().getBBox().height;
    }

    get boxWidth(): number {
        return this.textBox.node().getBBox().width;
    }

    get boxY(): number {
        return this.positionProps.y + this.conf.marginY;
    }

    set boxY(value: number) {
        this.positionProps.y = value;
        // this.render();
    }

    // Only call this if you have higher than thresh ratings and lower within thresh ratings to determine what side to render labels
    determineRenderDir(): 'right' | 'left' {

        let markerIndex: number;
        // console.log(`Thresh: ${this.threshhold}, Val-coord: ${this.valueCoordinate}`);

        if (this.valueCoordinate > this.threshhold)
            return 'left';
        else
            return 'right';

        const firstAboveThresh = this._allLabels.find((label, index) => {
            if (label.valueCoordinate > this.threshhold) {
                markerIndex = index;
                return true;
            }
            return false;
        });
        // lowestRating = this._allLabels[this._allLabels.length - 1];
        let lowestRating = this._allLabels[this._allLabels.length - 1];
        this._allLabels.forEach(rating => {
            if (rating.valueCoordinate < lowestRating.valueCoordinate)
                lowestRating = rating;
        });

        // TODO: Work on this to account for margins
        const firstBelowThresh = this._allLabels[markerIndex - 1];
        // console.log('Thresh vals: ', !!firstAboveThresh, !!firstBelowThresh);

        // TODO: Tmp fix to face lower rated items to left
        if (this.valueCoordinate > this.threshhold)
            return 'left';
        // Tmp Fix End


        if (firstAboveThresh && firstBelowThresh) {
            const spaceLeft: number = firstAboveThresh.baseX - firstBelowThresh.baseX,
                spaceRight: number = this.vBoxWidth - lowestRating.baseX;
            // console.log('Hello: ', spaceLeft, spaceRight);

            return spaceLeft > spaceRight ? 'left' : 'right';
        } else if (firstAboveThresh) {
            return 'right';
        } else {
            // TODO: Not sure what to do here yet...
            return 'left';
        }

    }

    render(delay: boolean = false): void {
        // TODO: Create vars for Xpos from hookline with margin and dropline before cutoff with margin. Dropline: +8 (left), Hookline -16 (right);
        const { x } = this.positionProps;
        const y = this.boxY;
        let boxX: number = x + 16;
        // Available width for text box
        let textBoxWidth: number;
        const cutoffThreshold: number = this.threshhold;
        let renderDir: 'left' | 'right';

        try {
            renderDir = this.determineRenderDir();
        } catch (error) {
            console.log('Could not determine render direction. Defaulting to "left"');

            renderDir = 'left';
        }

        // console.log(this.valueCoordinate, renderDir, this.text);


        // TODO: What does this do...? Determines width maybe...?
        /**
         * Seems to calculate initial width
         */
        // if (false && this.valueCoordinate > cutoffThreshold && renderDir === 'left') {
        if (this.valueCoordinate > cutoffThreshold) {
            textBoxWidth = this.textBox.node().getComputedTextLength();
            // console.log('Label Width ', textBoxWidth);
            boxX = this.baseX - textBoxWidth - 16;
            // this.textBox.attr('width', textBoxWidth).attr('x', 0);


            // OLD CODE
            // const belowThesh = this._allLabels.filter(label => label.valueCoordinate < cutoffThreshold).sort((a, b) => a.valueCoordinate - b.valueCoordinate);
            // console.log(belowThesh.map(item => item.valueCoordinate));
            /*  if (this._allLabels.length > 1 && belowThesh.length) {
                 const lastBeforeThresh = belowThesh[belowThesh.length - 1];
                 // Add 8px margin between text and lastBeforeThreshold
                 const xPosLimit: number = lastBeforeThresh.valueCoordinate - 8;
                 textBoxWidth = x - 16;
                 boxX = xPosLimit - textBoxWidth;
             } else {
                 textBoxWidth = Math.floor(boxX) - 16;
             } */
        }
        else {
            textBoxWidth = Math.floor(this.linescaleWidth - boxX);
        }

        // Sets the x position
        this.textBox.attr('x', boxX).attr('y', y);

        // Wrap the label text here
        if ((!this.wrapped && renderDir === 'right')) {
            this.textBox.call(wrap, textBoxWidth, false);
            this.wrapped = true;

            // After wrapping calc margin between text box and drop line then move text box against dropline by that amount IF is flipped label
            // if (this.valueCoordinate <= cutoffThreshold && renderDir === 'left' && this.boxWidth < textBoxWidth) {
            //     console.log('Should flip text...?');

            //     boxX = boxX + (this.baseX - (boxX + this.boxWidth)) - 16;
            //     this.textBox.attr('x', boxX).selectAll('tspan').attr('x', boxX);
            // }
        } else if (!this.wrapped && renderDir == 'left' && textBoxWidth > this.baseX - 16) {
            this.textBox.call(wrap, this.baseX - 16, true, true);
            let maxLineWidth: number = 0;
            this.textBox.selectAll<SVGTSpanElement, any>('tspan').each(function () {
                const width = this.getComputedTextLength();
                if (maxLineWidth < width)
                    maxLineWidth = width;
            })
            textBoxWidth = Math.floor(maxLineWidth);
            boxX = this.baseX - textBoxWidth - 16;

            const lines = this.textBox.selectAll('tspan');
            lines.each(function () {
                select(this).attr('x', boxX);
            });
            this.wrapped = true;
        }

        // Position the rating line (two separate svg elements for the line)
        // TODO: Correct this conditional
        // if (this.valueCoordinate > cutoffThreshold && renderDir === 'right') {
        // if (true || this.valueCoordinate > cutoffThreshold) {
        if (this.valueCoordinate < cutoffThreshold) {
            this.dropLine
                .attr('x1', x)
                .attr('y1', this.baseY)
                .attr('x2', x)
                .attr('y2', this.tailY)
                .attr('class', 'item-line' + (this.isAnchor ? ' anchor' : ''));
            this.tailLine
                .attr('x1', x)
                .attr('y1', this.tailY)
                .attr('x2', x + 8)
                .attr('y2', this.tailY)
                .attr('class', 'item-line right');
        } else {
            this.dropLine
                .attr('x1', x)
                .attr('y1', this.baseY)
                .attr('x2', x)
                .attr('y2', this.tailY)
                .attr('class', 'item-line' + (this.isAnchor ? ' anchor' : ''));
            this.tailLine
                .attr('x1', x)
                .attr('y1', this.tailY)
                .attr('x2', x - 8)
                .attr('y2', this.tailY)
                .attr('class', 'item-line');
            this.textBox.attr('class', 'text-box right');
            // console.log(this.boxWidth);
        }
        // MorphSVGPlugin.converToPath(this.dropLine);
    };

    remove(): void {
        this.textBox.remove();
        this.dropLine.remove();
        this.tailLine.remove();
    }

}

export function wrap(myText: Selection<SVGTextElement, any, any, any>, width: number, alignChildren: boolean = true, isLabel: boolean = false) {

    if (alignChildren) {
        width = width - 64;
    }
    const labelXPos: number = Math.floor(Number(myText.attr('x')));

    myText.each(function () {
        const text = select(this);
        const rawText: string = text.text();

        const words: string[] = text.text().trim().split(/\s+/);
        let word: string,
            // List containing words of a single line (tspan). Will be reassigned on every break.
            line: string[] = [];
        // lineNumber = 0,
        const lineHeight = 1.1, // ems
            y = text.attr("y");

        words.reverse();

        const dy = text.attr("dy") ? parseFloat(text.attr("dy")) : 0;
        let tspan = text.text(null).append("tspan")
            .attr("y", y)
            .attr("dy", dy + "em");

        if (alignChildren) {
            tspan.attr("x", 0);
        } else {
            tspan.attr('x', labelXPos);
        }

        const linesText: string[] = [];
        const lines: Selection<SVGTSpanElement, any, any, any>[] = [tspan];


        if (rawText.includes('<br>')) {
            // Respect the breaks
            linesText.splice(0, linesText.length, ...rawText.split('<br>'));
            const myLines: string[] = linesText.slice();
            // To correctly append them so it reads top to bottom
            myLines.reverse();
            linesText.reverse();

            while (myLines.length) {
                console.log('Cycle');

                tspan.text(myLines.pop());
                tspan.attr("y", y);
                if (alignChildren) {
                    tspan.attr("x", 0);
                } else {
                    tspan.attr('x', labelXPos);
                }
                if (myLines.length) {
                    lines.push(tspan);
                    tspan = text.append("tspan");
                }
            }
        } else {
            // console.log('Not here');

            while (word = words.pop()) {
                line.push(word);

                const currText: string = line.join(' ');
                linesText[0] = currText;
                tspan.text(currText);

                // If the tspan width exceeds to available width then break into a new tspan
                if (tspan.node().getComputedTextLength() > width) {
                    // Remove the last word that triggered the excess
                    line.pop();
                    // Set the item (a string) in the list to be concatenation after excess word removed
                    linesText[0] = line.join(' ');
                    // Replace the text of the current tspan with the result above
                    tspan.text(linesText[0]);
                    // Assign var with new array of one item (the excess word) 
                    line = [word];

                    // This add the leftover word to the list of lines
                    linesText.unshift(word);

                    tspan = text.append("tspan");
                    if (alignChildren) {
                        tspan.attr("x", 0);
                    } else {
                        tspan.attr('x', labelXPos);
                    }
                    tspan.attr("y", y).text(word);
                    lines.push(tspan);
                }

            }
        }
        // Set vertical position (dy attribute) for tspan elements
        // lines.reverse();
        if (alignChildren && !isLabel) {
            // scale guides alignment
            lines.forEach((line, index) => {
                // console.log('Line');

                // line.attr("dy", `${index * lineHeight * (alignChildren ? -1 : 1) + dy}em`)
                line.attr("dy", `${index * lineHeight * (alignChildren ? -1 : 1) + dy}em`)
            })
        } else if (isLabel) {
            // do stuff
            // Ratings alignment
            lines.forEach((line, index) => {
                line.attr("dy", `${(lines.length - 1 - index) * lineHeight * (alignChildren ? 1 : 1) + dy}em`)
            });
        } else {
            // Ratings alignment
            lines.forEach((line, index) => {
                // console.log('Line');

                line.attr("dy", `${(lines.length - 1 - index) * lineHeight * (alignChildren ? -1 : 1) + dy}em`)
            })
        }

        // TODO: Is this necessary?
        if (lines.length > 1) {
            linesText.forEach((line, index) => {
                lines[index].text(line);
            });
        }
    });

}

